import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Optional, Output, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

type inputType = "text" | "number" | "time" | "email" | "password" | "submit" | "button" | "file"

@Component({
  selector: 'flow-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormInputComponent implements ControlValueAccessor, OnInit {
  @Input() type: inputType = 'text';
  @Input() label: string = '';
  @Input() required: boolean = false;
  @Input() value: string | number = null;
  @Input() placeholder = '';
  @Input() infoTooltip = '';
  @Input() isDisabled: boolean = false;
  @Input() isReadonly: boolean = false;
  @Input() errorMessage = '';
  @Input() minNumber?: number;
  @Input() maxNumber?: number;
  @Input() maxLength?: number;
  @Input() errorMessageClass?: string;
  @Input() labelClass?: string;
  @Output() keypressEvent = new EventEmitter<KeyboardEvent>();
  @Output() inputEvent = new EventEmitter<Event>();

  constructor(
    @Optional() @Self() protected control: NgControl,
    private cdr: ChangeDetectorRef
  ) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.cdr.markForCheck();
  }

  private onChange: (value: string | number) => void = () => { };
  protected onTouched: () => void = () => { };

  writeValue(value: string): void {
    this.value = value ?? '';
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInputChange(event: Event): void {
    this.inputEvent.emit(event);
    const inputElement = event.target as HTMLInputElement;
    this.value = inputElement.value ?? '';

    const newValue =
      this.type === 'number'
        ? this.value === '' || Number.isNaN(inputElement.valueAsNumber)
          ? null
          : inputElement.valueAsNumber
        : this.value;

    this.onChange(newValue);
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this.cdr.markForCheck();
  }

  onKeypress(e: KeyboardEvent) {
    if (this.type === 'number') {
      this.keypressEvent.emit(e);
    }
  }
}
